import React from 'react';
import { connect } from 'react-redux';
import submitForm from '../../../utils/submitForm';

import FinancialTransactionsTable from '../../financialTransactions/Table';
import UserfinancialTransactionsFilter from './userFinancialTransactionsFilter';
import Pagination2 from '../../../components/Pagination2';
import Spin from '../../../components/loading';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

import * as financialTransactionsActions from '../../../redux/financialTransactions/actions';

class UserTransactionsList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: 1,
      errorText: locales('errors.default'),
      errorFlag: false,
      itemsPerPage: 20,
      filter: '',//`filter=(userId~eq~${this.props.userId})`,
    };
  }

  handleAlert = () => {
    AlertAndConfirmation({ text: this.state.errorText, type: 'error' });
    this.setState({ errorFlag: false });
  };

  buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&${this.state.query || 'sort=createdAt-desc'}`;
      return query;
    }
  };

  onPageChanged = data => {
    const { currentPage, totalPages, pageLimit } = data;
    this.setState({ currentPage: currentPage }, () => {
      const query = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllUserFinancialTransactions(this.props.userId, query + `${this.state.filter}`);
    });
  };

  filterAndSort = () => {
    let { filter, sort } = this.state;
    let query;
    if (sort && filter) query = `${filter}&${sort}`;
    else if (filter) query = `${filter}`;
    else if (sort) query = `${sort}`;
    this.setState({ query, currentPage: 1 }, () => {
      let searchQuery = this.buildSearchQuery(this.state.currentPage, this.state.itemsPerPage);
      this.props.fetchAllUserFinancialTransactions(this.props.userId, searchQuery);
    });
  };

  sortTable = query => {
    this.setState({ sortType: this.state.sortType === 'asc' ? 'desc' : 'asc' }, () => {
      query = `${query}-${this.state.sortType}`;
      this.setState({ sort: `sort=${query}` }, () => this.filterAndSort());
    });
  };

  applyFilters = event => {
    const queryString = submitForm(event, this.state.selectedRegions, this.state.selectedAmenities);
    this.setState({ filter: `${queryString}` }, () => this.filterAndSort());
  };

  render() {
    let { loading, message, failed, error } = this.props;
    let totalRecords = this.props.userFinancialTransactions.totalRecords || 0;
    let { currentPage, itemsPerPage, sortType } = this.state;
    return (
      <>
        {this.state.errorFlag && this.handleAlert()}
        <section className="p-1 col-12">
          <Spin spinning={loading}>
            <article>
              <main className="panel panel-default">
                {error ? (
                  <div className="alert alert-danger">{locales('messages.server.error')}</div>
                ) : (
                  <>
                    {failed && <div className="alert alert-danger">{message}</div>}
                    <div className="panel-heading">
                      <i className="fas fa-list-alt px-1"/>
                      {locales('titles.userFinancialTransacitons')}
                    </div>
                    <div className="panel-body">
                      <UserfinancialTransactionsFilter
                        applyFilters={this.applyFilters}
                        filterAndSort={this.filterAndSort}
                      />
                      <FinancialTransactionsTable
                        disabledSorts={['userFullName']}
                        pageNumber={currentPage}
                        pageSize={itemsPerPage}
                        sortType={sortType}
                        sortTable={this.sortTable}
                        financialTransactionsList={this.props.userFinancialTransactionsList}
                      />
                      <footer className="col-12 d-flex justify-content-center py-2">
                        <div className="pagination-container">
                          <Pagination2
                            totalRecords={totalRecords || 0}
                            pageLimit={itemsPerPage}
                            pageNeighbours={2}
                            onPageChanged={this.onPageChanged}
                            currentPage={currentPage}
                          />
                        </div>
                      </footer>
                    </div>
                  </>
                )}
              </main>
            </article>
          </Spin>
        </section>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.financialTransactionsReducer.loading,
    message: state.financialTransactionsReducer.message,
    failed: state.financialTransactionsReducer.failed,
    financialTransactions: state.financialTransactionsReducer.financialTransactions,
    financialTransactionsList: state.financialTransactionsReducer.financialTransactionsList,
    userFinancialTransactions: state.financialTransactionsReducer.userFinancialTransactions,
    userFinancialTransactionsList: state.financialTransactionsReducer.userFinancialTransactionsList,
    error: state.financialTransactionsReducer.error,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    fetchAllUserFinancialTransactions: (userId, query) =>
      dispatch(financialTransactionsActions.fetchAllUserFinancialTransactions(userId, query)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(UserTransactionsList);
